import React, { PureComponent } from 'react';
import { fieldPropTypes } from 'redux-form';
import { ToggleSimpleField } from 'components/FormFieldsSimple/ToggleSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class ToggleField extends PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
  };

  render() {
    const { input } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="12px">
        <ToggleSimpleField
          {...this.props}
          onChange={this.handleChange}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
